import { render, staticRenderFns } from "./Advice.vue?vue&type=template&id=785bbd5b&scoped=true&"
import script from "./Advice.vue?vue&type=script&lang=js&"
export * from "./Advice.vue?vue&type=script&lang=js&"
import style0 from "./Advice.vue?vue&type=style&index=0&id=785bbd5b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785bbd5b",
  null
  
)

export default component.exports